function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.8 8.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4,8.69A.81.81,0,0,0,8,8.46l6.59-6.59a.84.84,0,0,0,.24-.58.82.82,0,0,0-.24-.57L14.08.24A.8.8,0,0,0,13.5,0a.78.78,0,0,0-.57.24L7.4,5.77,1.87.24A.83.83,0,0,0,.72.24L.24.73A.76.76,0,0,0,0,1.3a.76.76,0,0,0,.24.57L6.82,8.46A.82.82,0,0,0,7.4,8.69Z",
    style: {
      fill: "#96008F"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpened);
export default __webpack_public_path__ + "static/media/opened.19f840b77ef9fc45ac6f444e448170e8.svg";
export { ForwardRef as ReactComponent };